import { render, staticRenderFns } from "./weekly.vue?vue&type=template&id=6f626bbe&"
import script from "./weekly.vue?vue&type=script&lang=js&"
export * from "./weekly.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports